import axios from "axios";
import { acceptHMRUpdate, defineStore } from "pinia";
import { ref } from "vue";

/**
 * Store for managing user data.
 */
export const useUserStore = defineStore("user", () => {
  // Refs
  const user = ref({});
  const unreadFeaturesCount = ref(0);

  // Actions
  /**
   * Fetches the current user data.
   * @param {Object} [options={}] - The options for fetching the current user.
   * @param {boolean} [options.forceFetch=false] - Whether to force fetch the data.
   * @returns {Promise<Object>} The fetched user data.
   */
  const fetchCurrentUser = async ({ forceFetch = false } = {}) => {
    if (Object.keys(user.value).length !== 0 && !forceFetch) {
      return;
    }

    try {
      const { data: fetchedUser } = await axios.get(`/api/user/current`);

      unreadFeaturesCount.value = fetchedUser.data.unread_updates_count || 0;
      user.value = fetchedUser.data;

      return user.value;
    } catch (error) {
      throw new Error(error);
    }
  };

  const resetUnreadFeaturesCount = () => {
    unreadFeaturesCount.value = 0;
  };

  return {
    user,
    fetchCurrentUser,
    unreadFeaturesCount,
    resetUnreadFeaturesCount,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useUserStore, import.meta.hot));
}
